import isEmpty from 'lodash/isEmpty'
import * as Newsbrief from '../'
import * as Modal from '../../../components/modal'
import * as Constants from './constants'

export const updateHeaderUrl = (update: Newsbrief.UpdateStateAction) =>
  ({
    ...update,
    type: isEmpty(update.rowId) ? Constants.ADD_HEADER_LINK_URL : Constants.UPDATE_HEADER_LINK_URL,
  })

export const closeModal = () => ({ type: Modal.closeModalConstant(Constants.LOGO_IMPORT) })

export const updateLogoModalField = (field: Modal.ModalField) =>
  ({ type: Modal.updateModalConstant(Constants.LOGO_IMPORT), field })



// WEBPACK FOOTER //
// ./src/pages/newsbrief/logo/actions.ts